const PICKER_TYPES = new Set(["date", "datetime-local", "time", "month", "week"]);

/**
 * Roughly as wide as what each type shows. Measured in the field's own font to
 * find where its text ends.
 */
const SAMPLE_TEXT: Record<string, string> = {
  date: "00-00-0000",
  "datetime-local": "00-00-0000, 00:00 AM",
  time: "00:00 AM",
  month: "September 0000",
  week: "Week 00, 0000",
};

/** Breathing room past the text, so a click just after the year still types. */
const SLACK_PX = 8;

let canvas: HTMLCanvasElement | null = null;

function textEnd(input: HTMLInputElement): number {
  const style = getComputedStyle(input);
  canvas ??= document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return Number.POSITIVE_INFINITY;
  context.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
  const width = context.measureText(SAMPLE_TEXT[input.type] ?? "").width;
  return parseFloat(style.paddingLeft) + width + SLACK_PX;
}

/**
 * Opens the native calendar on a click in the empty part of a date or time
 * field, not only on its small icon.
 *
 * Not on a click on the date text itself: while the picker is open the
 * browser sends the keyboard to it, so the field could no longer be typed in.
 * Text to type, the rest of the field to pick.
 *
 * One listener on the document rather than an `onClick` on every input, so a
 * date field added later behaves the same without anyone remembering to.
 */
export function openDatePickersOnClick(): void {
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!PICKER_TYPES.has(target.type) || target.disabled || target.readOnly) return;
    if (event.offsetX <= textEnd(target)) return;
    try {
      target.showPicker();
    } catch {
      // Older browsers, or a picker already open: the icon still works.
    }
  });
}
